// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressInfoItem_container__2PHEv"};